import queryString from 'query-string';
import { set, get, getKeys } from 'globals/storage';
import * as Storage from 'globals/storage';
import { BackendTestableFeatures } from '@workivate/tho-web-shared';

export const testableFeaturesEnabled = (): boolean => {
  if (IS_PRODUCTION) {
    return false;
  }

  const localStorageTestableFlag = get(getKeys().testable, true);
  const { testable: queryStringTestableFlag } = queryString.parse(
    location.search,
  );

  // Query string takes priority over everything else
  // this is required because there are places where testable flags can be used(such as routes, or constants)
  // where 'setTestableFlag' might not have been called by the time that code is evaluated.
  // In these cases the flag will still be in the query string, so we can use this to determine the correct state.
  if (queryStringTestableFlag !== undefined) {
    return JSON.parse(queryStringTestableFlag as string);
  }

  return localStorageTestableFlag !== null
    ? !!localStorageTestableFlag
    : window.WAM.ENV.testableDefault;
};

export const setTestableFlag = (isEnabled: boolean): void => {
  if (!IS_PRODUCTION) {
    set(getKeys().testable, isEnabled, true);
  }
};

export const isUnifiedLoginEnabled = () =>
  localStorage.getItem(Storage.storageKeys.isUnifiedLoginEnabled) === 'true';

// checks the query string and local storage variables
// for any back end features we want to forcibly enable/disable for this auth session
export const getUSLBackendTestableFeatures = async () => {
  const features = await BackendTestableFeatures.getTestableFeaturesEnabled({
    query: queryString.parse(window.location.search),
    IS_PRODUCTION: IS_PRODUCTION,
  });

  return features;
};
